//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";
import qAuModelTreeLight from "@/components/Generics/ModelTreeLight/qAuModelTreeLight.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";

export default {
    name: "MapRequestDataModel",
    components: {
        QAuModelPicker, qAuModelTreeLight, AQModal, AQCard
    },
    props: {
        treeDataModel: Array,
        rulesConditions: Array
    },
    data() {
        return {
            primary: { label: this.$t("generic.done"), disabled: true },
            dataForModelTree: [],
            requestDefined: false,
            defineRequestModal: false,
            objToSend: {},
            placeholderExternal: this.$t("liveView.filters.dataModelSearch"),
            data: [],
            computedDataForModelTree: [],
            copyOfModelTree: [],
            copyComputedVals: [],
            dataModelUsedInRules: []
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData"])
    },
    mounted() {
        this.rulesConditions.forEach(el => {
            this.dataModelUsedInRules.push(el.conditions.statement);
        });
        if (this.treeDataModel && this.treeDataModel.length) {
            this.computedDataForModelTree = this.treeDataModel;
            this.requestDefined = true;
        } else if (this.selectedPluginConfigData && this.selectedPluginConfigData.externalStart
            && this.selectedPluginConfigData.externalStart.dataModelFields && this.selectedPluginConfigData.externalStart.dataModelFields.length) {
            this.computedDataForModelTree = this.selectedPluginConfigData.externalStart.dataModelFields;
            this.requestDefined = true;
            this.$emit("showButton", this.requestDefined);
        }
        this.copyOfModelTree = Object.assign([], this.computedDataForModelTree);
    },
    methods: {
        defineRequestAction(action) {
            if (action === "primary") {
                this.data = [];
                this.requestDefined = true;
                this.data.push(this.objToSend);
                this.data.push(this.dataForModelTree);
                this.computedDataForModelTree = this.dataForModelTree;
                this.data.push({ requestVariable: this.requestDefined });
                this.$emit("dataToSave", this.data);
            } else if (action === "close") {
                this.requestDefined = !!this.computedDataForModelTree.length;
                this.$emit("showButton", this.requestDefined);
            }
            this.defineRequestModal = false;
        },
        afterHide() {
            this.$emit("input", false);
        },
        openModal() {
            this.defineRequestModal = true;
        },
        onModelSelect(modelSelect) {
            this.dataForModelTree = [];
            this.objToSend = {};
            let found = false;

            modelSelect.forEach(elem => {
                this.dataForModelTree.push(elem.formatted);
                this.copyOfModelTree.push(elem.formatted);

                if (!elem.isEmbeded) {
                    const { parents = [] } = elem;

                    this.objToSend[elem.key] = elem.formatted;
                    for (let i = 0; i < parents.length; i++) {
                        if (parents[i].node.isList) {
                            this.objToSend[`${parents[i].key}._path_`] = parents[i].formatted;
                        }
                    }
                }
            });
            this.copyOfModelTree = [...new Set(this.copyOfModelTree)];
            this.primary.disabled = !this.dataForModelTree.length;
            const difference = this.copyOfModelTree.filter(el => !this.dataForModelTree.includes(el));
            if (difference.length) {
                const pos = this.copyOfModelTree.indexOf(difference[0]) >= 0 ? this.copyOfModelTree.indexOf(difference[0]) : null;
                if (pos >= 0) {
                    this.copyOfModelTree.splice(pos, 1);
                }
            }
            for (let i = 0; i < this.dataModelUsedInRules.length; i++) {
                if (this.dataModelUsedInRules[i].includes(difference[0])) {
                    found = true;
                    break;
                }
            }
            if (found) {
                this.$toast.showNotify({
                    type: "warning",
                    message: this.$t("diagrams.components.externalStart.warningRemoveDataModelTitle"),
                    timeout: 2000
                });
            }
        }
    }
};
